import type { Reward } from "@/models/reward";
import { ApiClient } from "@/utils/apiClient";
import type { ApiPaginatedResponse, ApiPaginationPayload, ApiSortPayload } from "@/models/api";

export type RewardsListPayload =
  {
    category?: string;
    featured?: number;
    countryCode?: string;
    state?: string;
    city?: string;
    postCode?: string;
    radiusLatitude?: number;
    radiusLongitude?: number;
    sort?: string;
    radius?: number;
    radiusIncludeOnlineStores?: boolean;
    brandParentCategory?: string;
    search?: string;
    searchStores?: string;
  }
  & ApiPaginationPayload
  & ApiSortPayload;

export type RewardsSearchPayload =
  {
    query: string;
    category?: string;
    orderBy?: string;
    featured?: number;
  }
  & ApiPaginationPayload;

export type RewardListGetResponse = ApiPaginatedResponse<{
  items: Reward[];
}>

export abstract class RewardApiService {
  public static async get(payload: RewardsListPayload): Promise<RewardListGetResponse> {
    const response = await ApiClient.getClient().get<RewardListGetResponse>('/rewards', {
      params: payload,
    });
    return response.data;
  }

  public static async search(payload: RewardsSearchPayload): Promise<RewardListGetResponse> {

    const response = await ApiClient.getClient().get<RewardListGetResponse>('/rewards/search', {
      params: payload,
    });
    return response.data;
  }
}